// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBYcNUWU_kVDEU3m7EkXJ4iyzM1NboHjHw",
  authDomain: "ninety-nine-darts-90c84.firebaseapp.com",
  projectId: "ninety-nine-darts-90c84",
  storageBucket: "ninety-nine-darts-90c84.firebasestorage.app",
  messagingSenderId: "266236462687",
  appId: "1:266236462687:web:bac0c5e8cef1d11889fdea",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
